import api from "./api";

class MemberService {
  static getAll() {
    return api.get("/member");
  }

  static getPaginatedMembers(pageNumber, itemsPerPage) {
    // eslint-disable-next-line no-template-curly-in-string
    return api.get(`/member/${pageNumber}/${itemsPerPage}`);
  }

  static getById(id) {
    return api.get(`/member/${id}`);
  }

  static create(data) {
    return api.post("/member", data);
  }

  static update(id, data) {
    return api.put(`/member/${id}`, data);
  }

  static delete(id) {
    return api.delete(`/member/${id}`);
  }

  static search(term, pageNumber, itemsPerPage) {
    return api.get(`/member/${term}/${pageNumber}/${itemsPerPage}`);
  }

  static fullSearch(term) {
    return api.get(`/member/full/${term}`);
  }
}

export default MemberService;
